export default {
	getById(id, prof, cb, ecb, config) {
		this.http
			.get(`/user/${id}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/user', form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/user', {
				params
			})
			.then((response) => cb && cb(response))
	},
	remove(id, cb, ecb) {
		this.http
			.delete(`/user/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	changePwd({ id, newpass }, cb, ecb) {
		this.http
			.post('/user/changepwd', {
				id: id,
				newpass: newpass
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getVouchers(memberid, cb, ecb) {
		this.http
			.post('/member/queryVoucher', {
				memberid
			})
			.then((response) => cb && cb(response))
	},
	getAddresses(id, cb, ecb) {
		this.http
			.get('/user/getAddresses/' + id, {})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	updateAddress(addr, cb, ecb, config = {}) {
		this.http
			.post('/user/updateAddress', addr, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	removeAddress(id, cb) {
		this.http.get('/user/removeAddress/' + id, {}).then((res) => {
			cb(res)
		})
	},
	setDefaultAddress(id, cb) {
		this.http.get('/user/setDefaultAddress/' + id, {}).then((res) => {
			cb(res)
		})
	},
	getDefaultAddress(cb) {
		this.http.get('/user/getDefaultAddress/', {}).then((res) => {
			cb(res)
		})
	},
	getOauths(id, cb, ecb) {
		this.http
			.get('/oauth/getByUserId/' + id, {})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	saveProfile(form, cb) {
		this.http.post('/user/saveProfile/', form).then((res) => {
			cb(res)
		})
	},
	getProfile(id, cb) {
		this.http.get(`/user/getProfile/${id}`).then((res) => {
			cb(res)
		})
	},
	modifyPassword(form, cb, ecb) {
		this.http
			.post('/user/modifypassword', form, { alertError: false })
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	register(form, cb, ecb, config) {
		this.http
			.post('/user/register/', form, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	registerByEmail(form, cb, ecb, config) {
		this.http
			.post('/user/registerByEmail/', form, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getUserInfo(cb) {
		this.http.get('/user/getUserInfo/').then((res) => {
			cb(res)
		})
	},
	confirmMobile(mobile, cb, ecb) {
		this.http
			.post('/user/confirmMobile/', { mobile }, { alertError: false })
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	}
}
